import { ResultFile } from '@alilc/lowcode-types';
import { createResultFile } from '../../../../../../../utils/resultHelper';

export default function getFile(): [string[], ResultFile] {
    const file = createResultFile(
        'craco.config',
        'js',
        `
const CracoLessPlugin = require('craco-less');
const { loaderByName } = require("@craco/craco");
const CracoAlias = require("craco-alias");
// 更多 craco配置 https://craco.js.org/docs/
module.exports = {
    eslint: {
        enable: false /* (default value) */,
    },
    // 更多webpak配置 https://webpack.docschina.org/
    // webpack:{
    //     configure:{
    //     }
    // },
    plugins: [
        {
            plugin: CracoAlias,
            options: {
                source: "options",
                baseUrl: "./",
                aliases: {
                    "@src": "./src",
                    "@utils": "./src/utils",
                    "@assets": "./src/assets",
                }
            }
        },
        {
            plugin: CracoLessPlugin,
            options: {
                modifyLessRule(lessRule, context) {
                    // You have to exclude these file suffixes first,
                    // if you want to modify the less module's suffix
                    lessRule.exclude = /\\.m\\.less$/;
                    return lessRule;
                },
                modifyLessModuleRule(lessModuleRule, context) {
                    // Configure the file suffix
                    lessModuleRule.test = /\\.m\\.less$/;
                    // Configure the generated local ident name.
                    const cssLoader = lessModuleRule.use.find(loaderByName("css-loader"));
                    cssLoader.options.modules = {
                        localIdentName: "[local]_[hash:base64:5]",
                    };
        
                    return lessModuleRule;
                },
                lessLoaderOptions: {
                    lessOptions: {
                        modifyVars: { '@primary-color': '#1DA57A' },
                        javascriptEnabled: true,
                    },
                },
            },
        }
    ],
};
    `,
    );

    return [[], file];
}




